import { Classes } from "../../theme/Classes"

export const Card = ({ children, role = "noBordered", style, width  = '100%' }) => {

    return (
        <>
            {role === "noBordered" &&
                <div style={{width: width,...style}}>
                    <div style={Classes.Card.NoBorderedCard}>
                        {children}
                    </div>
                </div>
            }
            {role === "leftBordered" &&
            <div style={{width: width,...style}}>
                <div style={Classes.Card.LeftBorderedCard}>
                    {children}
                </div>
                </div>
            }
            {role === "subscription" &&
            <div style={{width: width,...style}}>
                <div style={Classes.Card.Subscription}>
                    {children}
                </div>
                </div>
            }
        </>

    )
}